$(document).ready(function() {
  function stopVideo(modal) {
    var iframe = modal.find("iframe");
    if (iframe.length) {
      var src = iframe.attr("src");
      iframe.attr("src", src); 
    }
    var video = modal.find("video");
    if (video.length) {
      video.get(0).pause();
      video.get(0).currentTime = 0;
    }
  }
  $(".video-play-btn svg").on("click", function() {
    var modal = $(".video-modal");

    modal.fadeIn(200).css("display", "flex");

    var iframe = modal.find("iframe");
    if (iframe.length) {
      var src = iframe.attr("src");
      if (!src.includes("autoplay=1")) {
        iframe.attr("src", src + (src.includes("?") ? "&" : "?") + "autoplay=1");
      }
    }

    var video = modal.find("video");
    if (video.length) {
      video.get(0).play();
    }
     $("body").addClass("video-popup-open");
    $("body").addClass("overflow-hidden");
     window.scrollTo(0, 0);
     $(".new_image_text_section").css("margin-top", "100%");
  });

  $(".video-close").on("click", function() {
    var modal = $(".video-modal");
    modal.fadeOut(200);
    stopVideo(modal);
     $("body").removeClass("video-popup-open");
    $("body").removeClass("overflow-hidden");
     $(".new_image_text_section").css("margin-top", "");
  });

  $(".video-modal").on("click", function(e) {
    if ($(e.target).is(".video-modal")) {
      $(this).fadeOut(200);
      stopVideo($(this));
       $("body").removeClass("video-popup-open");
    $("body").removeClass("overflow-hidden");
     $(".new_image_text_section").css("margin-top", "");
    }
  });

  // var bannerSection = $('.new_banner_section');
  // var header = $('.new_header_section');

  // $(window).on('scroll', function () {

  //   var scrollTop = $(window).scrollTop();
  //   var bannerOffset = bannerSection.offset().top;
  //   var bannerHeight = bannerSection.outerHeight();

  //   if (scrollTop > bannerOffset + bannerHeight - 100) {
  //     header.addClass('header-scrolled');
  //   } else {
  //     header.removeClass('header-scrolled');
  //   }

  // });

   $('.product-tab-btn').on('click', function() {

    var tab = $(this).data('tab');
    var container = $(this).closest('.product-tabs');

    container.find('.product-tab-btn').removeClass('active');

    container.find('.product-tabs__content').removeClass('active');

    $(this).addClass('active');

    container.find('#' + tab).addClass('active');

  });

 if (window.location.href.indexOf("contact_posted=true") > -1) {
      window.location.href = "/pages/thank-you";
  }
});
